module.exports = __webpack_public_path__ + "media/img/event/Scholarships2U-Virtual-Scholarship-Fair-2020-Banner-fe700b8a7123aacaaf4085229c36b6c9.jpg";